import {Card as MantineCard} from '@mantine/core';

/**
 * Bordered card surface (with `Card.Section`) — design-layer pass-through over Mantine `Card`.
 * @registry Pass-through Mantine Card; import this instead of @mantine/core outside src/design.
 */
export const Card = MantineCard;
